<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <div class="container_dashboard" style="padding-top: 10px; padding-bottom: 10px;" *ngIf="!this.bodyLoaded">
    <h4 class="dtfbrochures__header_dark" *ngIf="!SelectAsset && !SelectContract">{{
      'Payoff.PayoffHeader' | translate }}</h4>
    <h4 class="dtfbrochures__header_dark" *ngIf="SelectAsset">{{ 'Payoff.PayoffSelectAsset'
      | translate }}</h4>
    <h4 class="dtfbrochures__header_dark" *ngIf="SelectContract">{{
      'Payoff.PayoffSelectContract' | translate }}</h4>
    <!-- <p *ngIf="SelectAsset && !isCanadaPortal" style=" padding-left: 41px;">{{ 'Payoff.AssetText' | translate }}</p>
    <p *ngIf="SelectContract && !isCanadaPortal" style=" padding-left: 41px;">{{ 'Payoff.ContractText' | translate }}</p> -->
    <div class="dtfbrochures__containerlong custom-container" *ngIf="!disableDashboard">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <div class="container_dashboard custom-dashboard" style="padding-top: 10px; padding-bottom: 10px;">
    <div class="mbfs-contact-us-page-inner && tile" style="padding-top: 15px; padding-bottom: 15px; padding-left: 21px; padding-right: 21px;">

     

      <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <!--Spinner on Login Load-->
        <div class="demo-container">
          <span>{{ 'Invoice.Loading' | translate }}</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br>
      </div>

      <div *ngIf="isVin">
        <p *ngIf="isCanadaPortal">{{ 'Payoff.pbyVin' | translate }}</p>
        <p *ngIf="!isCanadaPortal">{{ 'Payoff.pbyVin' | translate }}</p>
        <br>
        <div *ngIf="!isCanadaPortal">
          <p *ngIf="required" style="color: red;" >{{ 'Payoff.required' | translate }}</p>  
          <p *ngIf="error" style="color: red;"> {{ 'Payoff.error' | translate }} </p>  
        </div>
        <div *ngIf="isCanadaPortal">
          <p *ngIf="required" style="color: red;">{{ 'Payoff.required' | translate }}</p>  
          <p *ngIf="error" style="color: red;">{{ 'Payoff.error' | translate }}</p>       
        </div>
        <br>
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label *ngIf="isCanadaPortal">{{ 'Payoff.vinNum' | translate }}</mat-label>
          <mat-label *ngIf="!isCanadaPortal">{{ 'Payoff.vinNum' | translate }}</mat-label>
          <input matInput [(ngModel)]="inputValue"  #inputField="ngModel" minlength="17" maxlength="17"   pattern="^[a-zA-Z0-9]*$"  (keypress)="restrictSpecialChars($event)" required>
        </mat-form-field>
        <br>
        <button class="mbfs-button" [disabled]="!inputField.valid || inputField.errors?.pattern" (click)="ByVin()">{{ 'LoginModal.Continue' | translate }}</button>
        <button class="mbfs-button" (click)="backstep1()">{{ 'LoginModal.back' | translate }}</button>
        <br> 
      </div>

      <div *ngIf="!viewpayoff && MoreAccountsFlow">

         <p *ngIf="isCanadaPortal" style="width: 100%; font-size: larger;">{{ 'Payoff.ViewPayoffVerbiage1' | translate }}</p>
         <p *ngIf="!isCanadaPortal" style="width: 100%; font-size: larger;">{{ 'Payoff.ViewPayoffVerbiage1' | translate }}</p>
       
        <br>

        <h1 class="mercedes-me-login__column-headline2"></h1>
          
        <div class="card-grid">
          <div class="card">
            <p *ngIf="isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType1' | translate }}</p>
            <p *ngIf="!isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType1' | translate }}</p>
            <button class="card-button" (click)="onContinueClick('byAccount')">{{ 'LoginModal.Continue' | translate }}</button>
          </div>
          <div class="card">
            <p *ngIf="isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType2' | translate }}</p>
            <p *ngIf="!isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType2' | translate }}</p>
            <button class="card-button" (click)="onContinueClick('byAsset')">{{ 'LoginModal.Continue' | translate }}</button>
          </div>
          <div class="card">
            <p *ngIf="isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType3' | translate }}</p>
             <p *ngIf="!isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType3' | translate }}</p>
            <button class="card-button" (click)="onContinueClick('ForAccount')">{{ 'LoginModal.Continue' | translate }}</button>
          </div>
          <div class="card">
            <p *ngIf="isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType4' | translate }}</p>
             <p *ngIf="!isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType4' | translate }}</p>
            <button class="card-button" (click)="onContinueClick('ForAsset')">{{ 'LoginModal.Continue' | translate }}</button>
          </div>
          <div class="card" *ngIf="isCanadaPortal">
            <p *ngIf="isCanadaPortal" class="card-title">{{ 'Payoff.PayoffType5' | translate }}</p>
            <button class="card-button" (click)="onContinueClick('byVin')">{{ 'LoginModal.Continue' | translate }}</button>
          </div>
        </div>

       
      </div>

     <div *ngIf="viewpayoff">
      <p *ngIf="isCanadaPortal" style="width: 100%;">{{ 'Payoff.ViewPayoffVerbiage' | translate }}</p>
      <p *ngIf="!isCanadaPortal">{{ 'Payoff.ViewPayoffVerbiage' | translate }}</p>
       
      <br>
              <h1 class="mercedes-me-login__column-headline2"></h1>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                <input matInput style="outline: none;"
                  placeholder="Account Number or Status" #input type="text" (keyup)="applyviewpayoffFilter($event.target.value)" [(ngModel)]="value">
                <img matSuffix class="example-form-img"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
              </mat-form-field>
            <div style="float: right; margin-right: 10px;">
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-label *ngIf="isCanadaPortal">{{ 'Payoff.create' | translate }}</mat-label>
                <mat-label *ngIf="!isCanadaPortal">{{ 'Payoff.create' | translate }}</mat-label>
                <mat-select [(ngModel)]="selectedValue" name="Account">
                  @if(isCanadaPortal){
                    @for (Account of accounts; track Account) {
                      <mat-option *ngIf="isFrench" [value]="Account.value" (click)="onSelectPayoff()">{{Account.viewValueFR}}</mat-option>
                      <mat-option *ngIf="!isFrench" [value]="Account.value" (click)="onSelectPayoff()">{{Account.viewValue}}</mat-option>
                    }
                  }@else{
                    @for (Account of accountsForUs; track Account) {
                      <mat-option *ngIf="!isFrench" [value]="Account.value" (click)="onSelectPayoff()">{{Account.viewValue}}</mat-option>
                    }
                  }
                  
                </mat-select>
              </mat-form-field>       
            </div>
            <!-- <button class="mbfs-button" (click)="onSelectPayoff()">Submit</button> -->
        
      

        <mat-table [dataSource]="listLiveAndExpiredQuotesdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
          
          <ng-container matColumnDef="{{column.name}}"
            *ngFor="let column of initViewPayoffColumns; last as isLast; first as isFirst; ">
            
            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef   [disabled]="column.dispFormat === 'pay' || column.dispFormat === 'pdf' || column.dispFormat === 'expandicon' || column.dispFormat === 'checkbox'" 
              style="font-size: small; justify-content: center;">
              <div *ngIf="!isFrench"> {{column.display}}</div>
              <div *ngIf="isFrench"> {{column.displayFR}}</div>
            </mat-header-cell>

            <mat-cell *matCellDef="let element" style="justify-content: center;">
              <!-- <div *ngIf="isFirst"> <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                </mat-checkbox>
              </div> -->
              <div *ngIf="column.dispFormat=='expandicon'">
                <!-- <button mat-icon-button
                (click)="vindetails(element.terminationQuoteIdentifier.scheduleIdentifier.agreementNumber)" style="border: none;"> -->
                <mat-icon (click)="vindetails(element.agreementNumber)" >&nbsp;{{element == ViewPayOffListLive ? 'expand_less' : 'expand_more'}}</mat-icon>
                <!-- </button> -->
              </div>
              <span class="mobile-label">
                <div *ngIf="!isFrench"> {{column.display}} :</div>
                <div *ngIf="isFrench"> {{column.displayFR}} :</div>
              </span>
              <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                {{ element.amount | currency:'USD':true:'1.2-2' }}

              </div>
              <div *ngIf="column.dispFormat=='quoteNum'"> 
               {{element[column.name]}}

              </div>
              <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                {{element[column.name]}}
                 
              </div>
              <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat=='date'"> 
                {{element[column.name] | date:'MM/dd/yyyy'}}
              </div>
              <div *ngIf="column.dispFormat=='date1'"> 
                {{element.dateTime | date:'MM/dd/yyyy'}}
              </div>
              <div *ngIf="column.dispFormat=='pdf'">
                  <mat-icon *ngIf="!this.PDFBool" style="margin-left: 10px" matTooltip="Download pdf">
                    <img *ngIf="!isCanadaPortal" 
                      (click)="exportTableviewpayoff(element.agreementNumber,element.quotationNumber,element.status,element.amount,element.goodThrough,element.numberOfAssets,element.dateTime)"
                       matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/pdf.png">

                    <img *ngIf="isCanadaPortal" 
                      (click)="exportTableviewpayoffCA(element.agreementNumber,element.quotationNumber,element.status,element.amount,element.goodThrough,element.numberOfAssets,element.dateTime)"
                       matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/pdf.png">

                  </mat-icon>
              </div>
              <div *ngIf="column.dispFormat=='pay'">
                <div *ngIf="isLast">
                  <div *ngIf="agentview !='true'">
                    <button *ngIf="!isCanadaPortal && element.amount >= 0 && DTPAY" type="submit" [disabled]="element.status === 'EXPIRED' || element.onlinePayFlag == 'N'"
                      (click)="onPayNowClickViewPayOff(element.agreementNumber,element.amount,element.quotationNumber)"
                      class="mbfs-button" style=" width: 120px;">Pay Now</button>
                  </div>
                  <div *ngIf="agentview ==='true'">
                    <button *ngIf="!isCanadaPortal" type="submit" [disabled]="true" class="mbfs-button"
                      style=" width: 120px;">Pay Now</button>
                  </div>
                </div>
              </div>
            </mat-cell>
          </ng-container>
  

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="ViewPayOffListLive">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedViewPayoffColumns.length" style="justify-content: left; margin-left: 210px;">
              <div class="example-element-detail"
              [@detailExpand]="element == ViewPayOffListLive ? 'expanded' : 'collapsed'">
              <div class="example-element-description">
                <mat-table [dataSource]="vinDataSource1" multiTemplateDataRows class="mat-elevation-z8" matSort>
                  <ng-container matColumnDef="{{column.name}}"
                    *ngFor="let column of vininitColumns; last as isLast; first as isFirst;">
                    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="font-size: small;">
                      <div> {{column.display}}</div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <span class="mobile-label">
                        <div> {{column.display}} :</div>
                      </span>
                      <div *ngIf="column.dispFormat==''">
                        {{element[column.name]}}
                      </div>
                    </mat-cell>
                  </ng-container>
        
                  <ng-container matColumnDef="vinDetailsRes">
                    <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                      [attr.colspan]="vindisplayedColumns.length">
                    </mat-cell>
                  </ng-container>
        
                  <mat-header-row *matHeaderRowDef="vindisplayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let element; columns: vindisplayedColumns;" class="example-element-row"
                    [class.example-expanded-row]="vinDetailsRes === element"
                    (click)="vinDetailsRes = vinDetailsRes === element ? null : element">
                  </mat-row>
                  <mat-row *matRowDef="let row; columns: ['vinDetailsRes']" class="example-detail-row"></mat-row>
                 
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="vindisplayedColumns.length">
                      No records found.
                    </td>
                  </tr>
                </mat-table>
              </div>
          </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedViewPayoffColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedViewPayoffColumns;" class="example-element-row"
            [class.example-expanded-row]="ViewPayOffListLive === element"
            (click)="ViewPayOffListLive = ViewPayOffListLive === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['ViewPayOffListLive']" class="example-detail-row"></mat-row>

         
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="9" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="9" *ngIf="isFrench">Aucune donnée correspondant au filtre
              "{{input.value}}"
            </td>
          </tr>
        </mat-table>

        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>

      <div *ngIf="!viewpayoff">
        <div *ngIf="OpenTitleAuth">
          <!-- <h2><b>Payoff</b></h2> -->
          <p>{{ 'Payoff.Deliverymessage' | translate }}</p>
          <form #form="ngForm">
            <div style="display: flex;">
              <div class="col-sm-4" style="width: 75%;">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>{{ 'Invoice.SelectDate' | translate }}</mat-label>
                  <input matInput [min]="minDate" [max]="maxDate" [(ngModel)]="selectedDate"
                    [matDatepicker]="datepicker">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                      <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' | translate
                        }}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div style="display: flex;">
              <div class="col" *ngIf="!isInquiry">
                <input type="checkbox" [checked]="this.prefill" (change)="togglePrefill($event)" />
                <span> Use address on file</span>
              </div>
            </div>
            <div *ngIf="!isInquiry" class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <!-- <b for="name">{{ 'Payoff.PayoffRecipientName' | translate }}*</b><br> -->
                  <div class="col">
                    <input class="form-control" [disabled]="this.prefill" type="text" name="name" id="name"
                      placeholder="{{ 'Payoff.PayoffRecipientName' | translate }}*" [(ngModel)]="name" required
                      validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <!-- <b for="address">{{ 'Payoff.PayoffRecipientAddress1' | translate }}*</b><br> -->
                  <div class="col">
                    <input class="form-control" [disabled]="this.prefill" type="text" name="address" id="address"
                      placeholder="{{ 'Payoff.PayoffRecipientAddress1' | translate }}*" [(ngModel)]="address" required
                      validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <!-- <b for="address2">{{ 'Payoff.PayoffRecipientAddress2' | translate }}</b><br> -->
                  <div class="col">
                    <input class="form-control" [disabled]="this.prefill" type="text" name="address2" id="address2"
                      placeholder="{{ 'Payoff.PayoffRecipientAddress2' | translate }}" [(ngModel)]="address2" required
                      validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <!-- <b for="city">{{ 'Payoff.PayoffRecipientCity' | translate }}*</b><br> -->
                  <div class="col">
                    <input class="form-control" [disabled]="this.prefill" type="text" name="city" id="city"
                      placeholder="{{ 'Payoff.PayoffRecipientCity' | translate }}*" [(ngModel)]="city" required
                      validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="row">
                <div style="display: flex; margin-left: 1%;">
                  <div class="col-md-6">
                    <input class="form-control" [disabled]="this.prefill" type="text" name="zipCode" id="zipCode"
                      placeholder="{{ 'Payoff.PayoffRecipientZipCode' | translate }}*" [(ngModel)]="zipCode"
                      maxlength="10"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      required validateonblur value="" autocomplete="off">
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill">
                      <mat-select name="state" [disabled]="this.prefill" [(ngModel)]="state" placeholder="Select State">
                        <mat-option *ngFor="let request of stateLabelValues" [value]="request.value">
                          {{request.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <div>
                <button (click)="SetTitleAuth($event)" [disabled]="!this.tableLoaded" type="submit"
                  class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
                  <button *ngIf="SelectContract" (click)="backstep2Account()" [disabled]="!this.tableLoaded" type="submit"
                  class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>
                  <button *ngIf="!SelectContract" (click)="backstep2VinAsset()" [disabled]="!this.tableLoaded" type="submit"
                  class="mbfs-button">{{ 'LoginModal.back' | translate }}</button>
              </div>
              <div>
                <button type="button" class="mbfs-button cancel-button" (click)="payoffRedirect($event)">{{
                  'LoginModal.Cancel' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
        <div *ngIf="!OpenTitleAuth">
          <div *ngIf="SelectContract && !enablePayoffQuote">
            <div class="accountflex">
              <h1 class="mercedes-me-login__column-headline2"></h1>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                <input matInput style="outline: none;" (keyup)="applyFilter($event)"
                  placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                <img matSuffix class="example-form-img"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
              </mat-form-field>
            </div>
            <div class="row">
              <div class="col">
                <p>{{ 'Payoff.PayoffVerbiage1' | translate }}</p>
              </div>
            </div>
            <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                <div *ngIf="isFirst">
                  <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </div>
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div *ngIf="isFirst"> <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                    </mat-checkbox></div>
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="accountDetailsRes">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedColumns.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                [class.example-expanded-row]="accountDetailsRes === element"
                (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            <button type="submit" [disabled]="!this.tableLoaded" (click)="openPayoffQuote()" class="mbfs-button">{{
              'LoginModal.Continue' | translate }}</button>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{
                'LoginModal.back' | translate }}</button>
          </div>

          <div *ngIf="SelectContract && enablePayoffQuote">
            <div class="accountflex">
              <h1 class="mercedes-me-login__column-headline2">{{ 'Payoff.PayoffAccountPayoff' | translate }}</h1>
            </div>
            <ul>
              <li><b>{{ 'Payoff.AccountNumbers' | translate }}</b> {{this.displaycontractNumberList}} </li>
              <li><b>{{ 'Payoff.TotalAssets' | translate }}</b> {{this.assetTotal}} </li>
              <li><b>{{ 'Payoff.PayoffAmount' | translate }}</b>{{this.payoffTotal | currency:'USD':true:'1.2-2'}}</li>
              <li><b>{{ 'LoginModal.CustomerName' | translate }}: </b> {{this.customerName}} </li>
              <li><b>{{ 'LoginModal.TitleDeliveryAddress' | translate }}:  </b> {{this.name}} {{this.address}} {{this.address2}} {{this.city}} {{this.state}} {{this.zipCode}}
              </li>
              <li><b>{{ 'LoginModal.CustomerNumber' | translate }}:</b> {{this.thirdParty}}</li>
            </ul>
          
              <div role="contentinfo" style="text-align: end;">
                <div class="mbfs-copyright">
                  <button class="mbfs-button" *ngIf="isCanadaPortal" (click)="exportTableCA()">{{ 'Amortization.Download'
                    | translate }}</button>
                  <button class="mbfs-button" *ngIf="!isCanadaPortal" (click)="exportTableUS()">{{
                    'Amortization.Download' | translate }}</button>
                  <button class="mbfs-button" *ngIf="!isCanadaPortal" (click)="backstep2Addresspage()">{{
                      'LoginModal.back' | translate }}</button>
                </div>
              </div>
              <br>
            <mat-table [dataSource]="multipayoffdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initMultiPayoffColumns; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngIf="column.dispFormat=='pay'"> <!--Formats date Columns-->
                    <div *ngIf="isLast && !displayPayNow && !isPositive && !isInquiry">
                      <div *ngIf="agentview !='true'">
                        <button *ngIf="!isCanadaPortal && DTPAY" [disabled]="element.onlinePayFlag=='N' "
                          (click)="onPayNowClick(element.contractNumber,element.quoteAmount,element.quoteNumber)"
                          type="submit" class="mbfs-button">Pay Now</button>
                      </div>
                      <div *ngIf="agentview ==='true'">
                        <button *ngIf="!isCanadaPortal" type="submit" [disabled]="true" class="mbfs-button">Pay
                          Now</button>
                      </div>
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="payoffResponseBeanList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedMultiPayoffColumns.length">
                </mat-cell>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedMultiPayoffColumns"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedMultiPayoffColumns;" class="example-element-row"
                [class.example-expanded-row]="payoffResponseBeanList === element"
                (click)="payoffResponseBeanList = payoffResponseBeanList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['payoffResponseBeanList']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre</td>
              </tr>

            </mat-table>
            <br><br>
            <div *ngIf="!isCanadaPortal">
              <p><b>{{ 'Payoff.PayoffLegalHeader1' | translate }}</b> {{ 'Payoff.PayoffLegal1' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader2' | translate }}</b> {{ 'Payoff.PayoffLegal2' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader3' | translate }}</b> {{ 'Payoff.PayoffLegal3' | translate }}</p>
              <p>{{ 'Payoff.PayoffLegal5' | translate }}</p>
              <p>{{ 'Payoff.PayoffLegal4' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffWireHeader1' | translate }}</b></p>
              <p>{{ 'Payoff.PayoffWireVerbiage1' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage2' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage3' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage4' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage5' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffNonFleetHeader1' | translate }}</b> {{ 'Payoff.PayoffNonFleetVerbiage1' | translate
                }}</p>
              <p><b>{{ 'Payoff.PayoffFleetHeader1' | translate }}</b> {{ 'Payoff.PayoffFleetVerbiage1' | translate }}
              </p>
            </div>

            <div *ngIf="isCanadaPortal">
              <p> {{ 'Payoff.PayoffLegal1' | translate }}</p>
              <p> {{ 'Payoff.PayoffLegal2' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader3' | translate }}</b> {{ 'Payoff.PayoffLegal3' | translate }}</p>
              <p>{{ 'Payoff.PayoffLegal4' | translate }}</p>
            </div>

          </div>

          <div *ngIf="SelectAsset && !enableVinPayoff">
            <div class="accountflex">
              <h1 class="mercedes-me-login__column-headline2"></h1>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text"
                  [(ngModel)]="value">
                <img matSuffix class="example-form-img"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
              </mat-form-field>
            </div>
            <div class="row">
              <div class="col">
                <p>{{ 'Payoff.PayoffVerbiage2' | translate }}</p>
              </div>
            </div>
            <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                <div *ngIf="isFirst">
                  <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                    [checked]="selectionsingle.hasValue()&& isAllSelected()"
                    [indeterminate]="selectionsingle.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </div>
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div *ngIf="isFirst">
                    <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selectionsingle.toggle(element) : null"
                      [checked]="selectionsingle.isSelected(element)">
                    </mat-checkbox>
                  </div>
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="accountDetailsRes">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedColumns.length">
                </mat-cell>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                [class.example-expanded-row]="accountDetailsRes === element"
                (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            <button type="submit" [disabled]="!this.tableLoaded" (click)="openVinPayoff()" class="mbfs-button">{{
              'LoginModal.Continue' | translate }}</button>
            <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{
                'LoginModal.back' | translate }}</button>
          </div>

          <div *ngIf="SelectAsset && (enableVinPayoff && !enableAssetPayoffQuote)">
            <div class="accountflex">
              <h1 class="mercedes-me-login__column-headline2"></h1>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                <input matInput (keyup)="applyVinFilter($event)" placeholder="Account Number or Status" #input
                  type="text" [(ngModel)]="value">
                <img matSuffix class="example-form-img"
                  src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
              </mat-form-field>
            </div>
            <div class="row">
              <div class="col">
                <p>{{ 'Payoff.PayoffVerbiage3' | translate }}</p>
              </div>
            </div>
            <mat-table [dataSource]="vinDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initVinColumns; last as isLast; first as isFirst;">
                <div *ngIf="isFirst">
                  <mat-checkbox (change)="$event ? masterVinToggle() : null"
                    [checked]="selection2.hasValue() && isAllVinSelected()"
                    [indeterminate]="selection2.hasValue() && !isAllVinSelected()">
                  </mat-checkbox>
                </div>
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div *ngIf="isFirst"> <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection2.toggle(element) : null" [checked]="selection2.isSelected(element)">
                    </mat-checkbox></div>
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="assetListRes">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedVinColumns.length">
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedVinColumns"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedVinColumns;" class="example-element-row"
                [class.example-expanded-row]="assetListRes === element"
                (click)="assetListRes = assetListRes === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['assetListRes']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                  "{{input.value}}"</td>
              </tr>

            </mat-table>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            <button type="submit" [disabled]="!this.tableLoaded" (click)="openAssetPayoffQuote()" class="mbfs-button">{{
              'LoginModal.Continue' | translate }}</button>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep2Asset()" class="mbfs-button">{{
                'LoginModal.back' | translate }}</button>
          </div>

          <div *ngIf="SelectAsset && (enableVinPayoff && enableAssetPayoffQuote)">
            <ul>
              <li><b>{{ 'Payoff.AccountNumbers' | translate }}</b> {{this.displaycontractNumberList}} </li>
              <li><b>{{ 'Payoff.TotalAssets' | translate }}</b> {{this.assetTotal}} </li>
              <li><b>{{ 'Payoff.TotalVins' | translate }}</b> {{this.displayVinList}} </li>
              <li><b>{{ 'Payoff.PayoffAmount' | translate }}</b>{{this.payoffTotal | currency:'USD':true:'1.2-2'}}</li>
              <li><b>{{ 'LoginModal.CustomerName' | translate }}:</b> {{this.customerName}} </li>
              <li><b>{{ 'LoginModal.TitleDeliveryAddress' | translate }}: </b>{{this.name}} {{this.address}} {{this.address2}} {{this.city}} {{this.state}} {{this.zipCode}}
              </li>
              <li><b>{{ 'LoginModal.CustomerNumber' | translate }}:</b> {{this.thirdParty}}</li>
            </ul>
           
              <div role="contentinfo" style="text-align: end;">
                <div class="mbfs-copyright">
                  <button class="mbfs-button" *ngIf="isCanadaPortal" (click)="exportTableCA()">{{ 'Amortization.Download'
                    | translate }}</button>
                  <button class="mbfs-button" *ngIf="!isCanadaPortal" (click)="exportTableUS()">{{
                    'Amortization.Download' | translate }}</button>
                    <button class="mbfs-button" *ngIf="!isCanadaPortal" (click)="backstep2Addresspage()">{{
                      'LoginModal.back' | translate }}</button>
  
                </div>
              </div>
              <br>
            <mat-table [dataSource]="multipayoffdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
              <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}"
                *ngFor="let column of initMultiPayoffColumns; last as isLast; first as isFirst;">
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngIf="column.dispFormat=='pay'"> <!--Formats date Columns-->
                    <div *ngIf="isLast && !displayPayNow && !isPositive && !isInquiry">
                      <div *ngIf="agentview !='true'">
                        <button *ngIf="!isCanadaPortal && DTPAY" [disabled]="element.onlinePayFlag=='N' "
                          (click)="onPayNowClick(element.contractNumber,element.quoteAmount,element.quoteNumber)"
                          type="submit" class="mbfs-button">Pay Now</button>
                      </div>
                      <div *ngIf="agentview ==='true'">
                        <button *ngIf="!isCanadaPortal" type="submit" [disabled]="true" class="mbfs-button">Pay
                          Now</button>
                      </div>
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="payoffResponseBeanList">
                <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                  [attr.colspan]="displayedMultiPayoffColumns.length">
                </mat-cell>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedMultiPayoffColumns"></mat-header-row>
              <mat-row *matRowDef="let element; columns: displayedMultiPayoffColumns;" class="example-element-row"
                [class.example-expanded-row]="payoffResponseBeanList === element"
                (click)="payoffResponseBeanList = payoffResponseBeanList === element ? null : element">
              </mat-row>
              <mat-row *matRowDef="let row; columns: ['payoffResponseBeanList']" class="example-detail-row"></mat-row>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter</td>
                <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre</td>
              </tr>

            </mat-table>
            <br><br>

            <div *ngIf="!isCanadaPortal">
              <p><b>{{ 'Payoff.PayoffLegalHeader1' | translate }}</b> {{ 'Payoff.PayoffLegal1' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader2' | translate }}</b> {{ 'Payoff.PayoffLegal2' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader3' | translate }}</b> {{ 'Payoff.PayoffLegal3' | translate }}</p>
              <p>{{ 'Payoff.PayoffLegal4' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffWireHeader1' | translate }}</b></p>
              <p>{{ 'Payoff.PayoffWireVerbiage1' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage2' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage3' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage4' | translate }}</p>
              <p>{{ 'Payoff.PayoffWireVerbiage5' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffNonFleetHeader1' | translate }}</b> {{ 'Payoff.PayoffNonFleetVerbiage1' | translate
                }}</p>
              <p><b>{{ 'Payoff.PayoffFleetHeader1' | translate }}</b> {{ 'Payoff.PayoffFleetVerbiage1' | translate }}
              </p>
            </div>
            <div *ngIf="isCanadaPortal">
              <p> {{ 'Payoff.PayoffLegal1' | translate }}</p>
              <p> {{ 'Payoff.PayoffLegal2' | translate }}</p>
              <p><b>{{ 'Payoff.PayoffLegalHeader3' | translate }}</b> {{ 'Payoff.PayoffLegal3' | translate }}</p>
              <p>{{ 'Payoff.PayoffLegal4' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>